import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Placeholder = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  color: white;
`;

/** Primeira letra do nome + primeira letra do último sobrenome. */
export function getInitialsFromName(name) {
  if (!name || typeof name !== "string") return "";
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
}

const AvatarPlaceholder = ({ className, children }) => {
  return (
    <div>
      <Placeholder className={className}>
        {getInitialsFromName(children)}
      </Placeholder>
    </div>
  );
};

AvatarPlaceholder.defaultProps = {
  className: "",
  children: null
};

AvatarPlaceholder.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any
};

export default AvatarPlaceholder;
